<template>
  <v-row justify="center">
    <v-dialog
      v-model="show"
      persistent
      max-width="600"
    >
     <v-card>
        <v-card-title class="text-h5">
          Logs do status
        </v-card-title>
        <v-container fluid>
        
        <v-data-table
        :headers="headers"
        :items="items"
        :disable-sort="true"
        no-data-text="Nenhum log encontrado"
        hide-default-footer
      >
        <template v-slot:[`item.date`]="{ item }">
          {{ new Date(item.created_at).toLocaleString('pt') }}
        </template>
      </v-data-table>

        </v-container>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red darken-1"
            text
            @click="show = false"
          >
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
  export default {
    data: () => ({
      headers: [
        { text: 'Nome', align: 'start', value: 'user.name' },
        { text: 'Status', value: 'status.name' },
        { text: 'Horário', value: 'date' }
      ]
    }),
    props: {
      showModalLog: false,
      dataLogs: null
    },
    computed: {
      show: {
        get () {
          return this.showModalLog
        },
        set (value) {
          this.$emit('update:showModalLog', value)
        }
      },
      items: {
        get () {
          return this.dataLogs
        },
        set (value) {
          this.$emit('update:dataLogs', value)
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/modals/LogModal.vue